import React, { memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '@sport1/react-elements/Image'
import { getImageSource, useImageSource } from '../../../utils/ImageHelper'
import { FullscreenProps } from './FullscreenProps'

const FullscreenImage = ({ imageUrl, alt, width, height }: FullscreenProps): ReactElement => {
    const [imageData, onError] = useImageSource({ imageUrl })

    return (
        <Grid noExpand position="relative" height={height} width={width}>
            <Image
                src={getImageSource(imageData)}
                blurRadius={9}
                height={height}
                width={width}
                onError={onError}
                alt={alt}
            />
            <Grid noExpand position="absolute" height={height} width={width}>
                <Image
                    src={getImageSource(imageData)}
                    resizeMode="contain"
                    height={height}
                    width={width}
                    onError={onError}
                    alt={alt}
                />
            </Grid>
        </Grid>
    )
}

export default memo(FullscreenImage)
